import { storyChapters } from '@/mocks/characters';

export default function StorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-primary-600 text-sm font-medium tracking-wider mb-2">
            —— 剧情概览 ——
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            故事章节
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-[550px] mx-auto">
            四段章节，四重命运。跟随亚当君的脚步，在挣扎中寻找答案
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {storyChapters.map((chapter, index) => (
            <div
              key={index}
              className="group relative bg-background-50 rounded-lg overflow-hidden flex flex-col sm:flex-row transition-all duration-500 hover:-translate-y-1"
            >
              <div className="relative w-full sm:w-[200px] h-[180px] sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={chapter.image}
                  alt={chapter.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                    {chapter.chapter}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col justify-center flex-1">
                <h3 className="font-heading text-lg text-foreground-900 font-bold mb-2">
                  {chapter.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {chapter.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}